import actions from '../../actionTypes';

export default group => {
  return {
    type: actions.EDITED_GROUP,
    group
  };
};



// WEBPACK FOOTER //
// ./src/reducers/groups/actions/editedGroup.js